





































































































































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {ReceiptPickingListStore} from "@/modules/receiptsexpenses/receiptpickinglist/store";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {LadingPaymentType, ReceiptPaymentType} from "@/enums/type";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import {DebtCustomer} from "@/interfaces/entity";
import {ReceiptExpensePickingListPayStatus} from "@/enums/status";

@Component({
    name: "ReceiptCustomerPickingListExcel",
})
export default class extends mixins(CommonMixin) {
    @Prop({ type: Boolean, default: false }) readonly isPrint!: boolean;
    @Prop({ required: true }) readonly id!: any;

    ReceiptPaymentType = ReceiptPaymentType;
    LadingPaymentType = LadingPaymentType;
    ReceiptExpensePickingListPayStatus = ReceiptExpensePickingListPayStatus;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;

    get pickingList(): ReceiptExpensePickingList {
        return ReceiptPickingListStore.data[this.id];
    }

    get debts(): Array<DebtCustomer> {
        return this.getProp(this.pickingList, 'debtCustomers', []);
    }

    get totalMoney() {
        return this.debts.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue.money || 0);
        }, 0);
    }

    getVat(totalFee: any) {
        if (isNaN(totalFee)) return 0;
        return Math.ceil((totalFee - totalFee/1.1));
    }
}
